module.exports = __webpack_public_path__ + "img/TaxInfo.8cd0bff3.svg";